import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDeleteCertificate = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async ({
      sourceId,
      projectId,
      enrolleeId,
      certificateId,
    }: {
      sourceId: string;
      projectId: string;
      enrolleeId: string;
      certificateId: string;
    }) => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/enrollees/${enrolleeId}/certificates/${certificateId}`,
        {
          method: "DELETE",
          headers: {
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete certificate");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to delete certificate", error, data);
      },
    },
  );
};
